module.exports = __webpack_public_path__ + "static/media/Gtd-logo-outside.f5dc527a.svg";